import React, { ReactNode } from 'react';
import { Alert, Collapse } from 'antd';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spin from 'src/components/common/Spin';

type AccordionProps = {
  children: ReactNode;
  error?: boolean;
  errorTitle?: string;
  header?: string;
  loading?: boolean;
};

const iconPlus: IconProp = ['fal', 'plus'];
const iconMinus: IconProp = ['fal', 'minus'];

const Accordion: React.FC<AccordionProps> = ({ header, children, error, loading = false, errorTitle = 'Accordion content' }) => {
  return (
    <Collapse
      bordered={false}
      expandIconPosition={'right'}
      expandIcon={({ isActive }): React.ReactNode => (
        <FontAwesomeIcon size={'lg'} icon={isActive ? iconMinus : iconPlus} />
      )}
    >
      <Collapse.Panel header={header} key="1" className="accordion_element">
        <Spin spinning={loading}>
          {
            error ? (
              <Alert
                message={`An error has occurred when trying to get ${errorTitle}! Please try again later!`}
                type="error"
                showIcon
              />
            ) : children
          }
        </Spin>
      </Collapse.Panel>
    </Collapse>
  );
};
export default Accordion;
